
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import VWrapper from '@/components/shared/VWrapper.vue';
import AuditingTable from '@/components/auditing/AuditingTable.vue';
import Filter from '@/interfaces/api/Filter';
import { Auditing as AuditingModel } from '@/interfaces/models/Auditing';
import { Venue } from '@/interfaces/models/Venue';
import { getVenuesFromCookie } from '@/util/helper';

const app = namespace('app');
const auditing = namespace('auditing');

@Component({
  components: { VWrapper, AuditingTable },
})
export default class Auditing extends Vue {
  @auditing.Action('setFilter') public setFilter!: (filter: Filter) => void;
  @auditing.Action('fetch') public getItems!: any;

  @auditing.State((state) => state.pagination.total) public total!: number;
  @auditing.State('filter') public filter!: Filter;
  @auditing.State('items') public items!: AuditingModel[];
  @app.State('venues') public venues!: Venue[];

  get venuesFiltered() {
    if (this.$isAdmin()) {
      return this.venues;
    }

    const userVenuesList: string[] = getVenuesFromCookie();
    const userVenues: Venue[] = this.venues.filter((venue: Venue) => (userVenuesList || []).includes(venue._id));

    return userVenues || [];
  }

  public async mounted() {
    this.$startLoading('auditing');
    await this.setFilter({});
    await this.getItems({ page: 1 });
    this.$stopLoading('auditing');
  }

  public async onFilter(val: object) {
    this.$startLoading('auditing');
    this.setFilter(val);
    await this.getItems({ page: 1 });
    this.$stopLoading('auditing');
  }
}
